var _style, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublisher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#038387;}\n\t.st1{fill:#37C6D0;}\n\t.st2{fill:#1A9BA1;}\n\t.st3{opacity:0.2;enable-background:new    ;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,20.4H46c0.7,0,1.3,0.6,1.3,1.3v20.5c0,0.7-0.6,1.3-1.3,1.3h-8.4c-0.7,0-1.3-0.6-1.3-1.3V21.7 C36.3,21,36.9,20.4,37.6,20.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,46.2H24.5c-0.8,0-1.4-0.6-1.4-1.3v-5.7L34,36.7l9,2.4v5.7C43,45.6,42.4,46.2,41.6,46.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,17.8h-17c-0.8,0-1.4,0.6-1.4,1.4V32l10.2,1.2L43,32V19.2C43,18.5,42.4,17.8,41.6,17.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 32,
    className: "st2",
    width: 19.9,
    height: 7.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.4,25.4v15.2c0,0.1,0,0.2,0,0.2c-0.1,0.6-0.7,1.1-1.3,1.1h-7.9V24H31C31.8,24,32.4,24.6,32.4,25.4 C32.4,25.4,32.4,25.4,32.4,25.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33,25.4v14c0,1.1-0.9,1.9-1.9,1.9h-7.9V23.4H31C32.1,23.4,32.9,24.3,33,25.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.4,25.4v14c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0h-7.9V24H31C31.8,24,32.4,24.6,32.4,25.4 C32.4,25.4,32.4,25.4,32.4,25.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.8,25.4v14c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0h-7.3V24h7.3C31.2,24,31.8,24.6,31.8,25.4 C31.8,25.4,31.8,25.4,31.8,25.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.5262,
    y1: 43.1159,
    x2: 29.0682,
    y2: 24.8567,
    gradientTransform: "matrix(1 0 0 -1 0 66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#058F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#038489"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#026D71"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.1,23.9h13.5c0.7,0,1.3,0.6,1.3,1.3v13.5c0,0.7-0.6,1.3-1.3,1.3H17.1c-0.7,0-1.3-0.6-1.3-1.3V25.3 C15.7,24.5,16.3,23.9,17.1,23.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M23.9,27.6c0.8-0.1,1.7,0.2,2.4,0.7c0.6,0.5,0.9,1.3,0.8,2.1c0,0.5-0.1,1.1-0.4,1.5c-0.3,0.5-0.7,0.8-1.2,1 c-0.5,0.3-1.1,0.4-1.7,0.4h-1.6v3.1h-1.7v-8.8H23.9z M22.2,32h1.4c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.5-0.7,0.4-1.1 c0-1-0.6-1.5-1.7-1.5h-1.5V32L22.2,32z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 20.4,
    className: "st3",
    width: 0.6,
    height: 23.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 20.4,
    className: "st4",
    width: 0.6,
    height: 23.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublisher);
export default __webpack_public_path__ + "static/media/publisher.7a7b191944b5b29a72fa76bfb1b86387.svg";
export { ForwardRef as ReactComponent };